// extracted by mini-css-extract-plugin
export default {"card":"Favorite_card__Ikv-I"};